import { render, staticRenderFns } from "./bnvtext.vue?vue&type=template&id=4700345c&"
import script from "./bnvtext.vue?vue&type=script&lang=js&"
export * from "./bnvtext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports